<form [formGroup]="form">
    <mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
        <mat-expansion-panel-header class="py-5 px-4">
            <mat-panel-title class="d-flex">
                <div class="container d-flex flex-column">
                    <h2 class="header-title" [class.complete]="form.valid && !form.pristine" [class.error]="!form.valid && !form.pristine">
                        {{ title }}
                    </h2>
                </div>
                <div>
                    <mat-icon *ngIf="form?.pristine && !panelOpen" class="header-toggle">
                        expand_more
                    </mat-icon>
                    <mat-icon *ngIf="form?.pristine && panelOpen" class="header-toggle">
                        expand_less
                    </mat-icon>
                    <mat-icon *ngIf="!form?.pristine && form?.valid" class="header-toggle complete">
                        checked
                    </mat-icon>
                    <mat-icon *ngIf="!form?.pristine && !form?.valid" class="header-toggle error">
                        close
                    </mat-icon>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mx-2">
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" appearance="outline" hideRequiredMarker>
                        <mat-label>Organization<span class="required-input">*</span></mat-label>
                        <input type="text"
                            placeholder="Select Organization"
                            matInput
                            [formControl]="orgControl"
                            [matAutocomplete]="auto">
                            <mat-error *ngIf="orgControl.invalid">
                                Please select a valid Organization
                            </mat-error>
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onOrgSelectionChanged($event)" [displayWith]="displayOrgFn">
                            <mat-option *ngFor="let organization of filteredOrganizations | async" [value]="organization">
                                {{ organization.organization_name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" appearance="outline" hideRequiredMarker>
                        <mat-label>Reference ID<span class="required-input">*</span></mat-label>
                        <input type="text" matInput formControlName="reservation_reference_id">
                        <mat-error *ngIf="!form?.get('reservation_reference_id')?.value">Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" class="form-input" appearance="outline">
                        <mat-label>Booking Date</mat-label>
                        <input matInput [matDatepicker]="bookingDatePicker" formControlName="booking_date">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="bookingDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #bookingDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" class="form-input" appearance="outline" hideRequiredMarker>
                        <mat-label>Arrival Date<span class="required-input">*</span></mat-label>
                        <input matInput [matDatepicker]="arrivalDatePicker" formControlName="arrival_date" [max]="departureDateValue">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-error *ngIf="!form.get('arrival_date')?.value">Required</mat-error>
                        <mat-error *ngIf="form.get('arrival_date')?.value && form.get('arrival_date')?.hasError('matDatepickerMax')">Arrival date must be before Departure date</mat-error>
                        <mat-datepicker-toggle matSuffix [for]="arrivalDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #arrivalDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" class="form-input" appearance="outline" hideRequiredMarker>
                        <mat-label>Departure Date<span class="required-input">*</span></mat-label>
                        <input matInput [matDatepicker]="departureDatePicker" formControlName="departure_date" [min]="arrivalDateValue">
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-error *ngIf="!form.get('departure_date')?.value">Required</mat-error>
                        <mat-error *ngIf="form.get('departure_date')?.value && form.get('departure_date')?.hasError('matDatepickerMin')">Departure date must be after Arrival date</mat-error>
                        <mat-datepicker-toggle matSuffix [for]="departureDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #departureDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Reservation Cost (USD)</mat-label>
                        <input type="number" class="right-align-text" matInput formControlName="reservation_cost" placeholder="0.00" step="0.01" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                        <span matPrefix>$&nbsp;</span>
                    </mat-form-field>
                </div>
            </div>
            <mat-action-row class="mt-4 d-flex flex-row align-content-center">
                <div class="d-flex align-items-center text-muted" style="margin-right: auto;">
                    <span class="required-input">*</span>&nbsp;- Organization, Reference ID, Arrival and Departure date is required
                </div>
            </mat-action-row>
        </div>
    </mat-expansion-panel>
</form>
